import { PureComponent } from "react";
import componentStyles from "./social-footer-component.scss";
import PaletteIconsComponent from "./palette-icons/palette-icons-component";
import PictureComponent from "components/core/picture/picture-component";

import heartImg from "/static/img/heart_small.png";

export default class SocialFooterComponent extends PureComponent {
  render() {
    const { nameSignature, SocialFooterLinks } = this.props;
    return (
      <div className="social-footer-component">
        <div className="items-container">
          <div className="made-with-love-sentence">
            Made with{" "}
            <PictureComponent
              className="red-heart"
              src={heartImg}
              alt="red heart"
              extraCloudinaryTransformations={{
                width: 16
              }}
            />{" "}
            by {nameSignature ? `${nameSignature} from` : ""} monday.com
          </div>
          <PaletteIconsComponent SocialFooterLinks={SocialFooterLinks} />
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
